// src/pages/Investment.jsx
import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
// import { motion } from "framer-motion";
// import { FaApple, FaGooglePlay } from 'react-icons/fa';
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
// import { useLanguage } from "../../contexts/LanguageContext";
import "./Investment.css";
import InvestmentHero from "../../components/InvestmentHero/InvestmentHero";
import InvestmentAbout from "../../components/InvestmentAbout/InvestmentAbout";
import WhyInvest from "../../components/WhyInvest/WhyInvest";
import PartnershipModels from "../../components/PartnershipModels/PartnershipModels";
import InvestmentTiers from "../../components/InvestmentTiers/InvestmentTiers";
import FinancialProjections from "../../components/FinancialProjection/FinancialProjection";
import ExitStrategy from "../../components/ExitStrategy/ExitStrategy";
import InvestmentCTA from "../../components/InvestmentCTA/InvestmentCTA";
import DownloadButtons from "../../components/DownloadButtons/DownloadButtons";
import InvestedMoneyUsed from "../../components/InvestedMoneyUsed/InvestedMoneyUsed";
import ShortTermInvestment from "../../components/ShortTermInvestment/ShortTermInvestment";
// import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
import FloatingWebsiteNavigation from "../../components/FloatingWebsiteNavigation/FloatingWebsiteNavigation";
import InvestmentCTA2 from "../../components/InvestmentCTA2/InvestmentCTA2";

const Investment = () => {
  const location = useLocation();
  const investmentCTA2Ref = useRef(null);

  useEffect(() => {
    // Check if we should scroll to InvestmentCTA2 component
    if (location.state?.scrollToInvestmentCTA2 && investmentCTA2Ref.current) {
      setTimeout(() => {
        investmentCTA2Ref.current.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }, 100); // Small delay to ensure component is rendered
    }
  }, [location.state]);

  return (
    <>
    <div className="investment-main-container">
      <div className="nav-desktop-only">
        <NavBar />
      </div>
      <InvestmentHero/>
      <InvestmentAbout/>
      <WhyInvest/>
      {/* <ShortTermInvestment/> */}
      <InvestedMoneyUsed/>
      <PartnershipModels/>
      <InvestmentTiers/>
      <FinancialProjections/>
      <ExitStrategy/>
      {/* <InvestmentCTA/> */}
      <div ref={investmentCTA2Ref}>
        <InvestmentCTA2/>
      </div>
      <Footer />
      </div>
      <FloatingWebsiteNavigation />
    </>
  );
};

export default Investment;
